import React from "react";
import { Box, Typography, Link, Container } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const PrivacyPolicy = () => {
  const theme = useTheme();

  return (
    <Container maxWidth="md" sx={{ my: 5 }}>
      <Box
        sx={{
          p: 4,
          bgcolor: theme.palette.background.paper,
          borderRadius: 2,
          boxShadow: 3,
        }}
      >
        <Typography variant="h4" gutterBottom>
          Privacy Policy
        </Typography>

        <Typography variant="body2" paragraph>
          La presente informativa è resa ai sensi dell’art. 13 del Regolamento (UE)
          2016/679 (“GDPR”) e descrive le modalità di trattamento dei dati personali
          degli utenti che consultano il sito web.
        </Typography>

        <Typography variant="h6" gutterBottom>
          Titolare del Trattamento
        </Typography>
        <Typography variant="body2" paragraph>
          <strong>Nome:</strong> Andrea Ricci
          <br />
          <strong>Email:</strong>{" "}
          <Link href="mailto:andrea.ricci94@gmail.com">
            andrea.ricci94@gmail.com
          </Link>
        </Typography>

        <Typography variant="h6" gutterBottom>
          Tipologie di Dati Trattati
        </Typography>
        <Typography variant="body2" paragraph>
          Il sito non raccoglie dati personali a fini di profilazione o marketing.
          Possono tuttavia essere trattati:
        </Typography>
        <Typography component="ul" variant="body2" sx={{ pl: 3 }}>
          <Typography component="li">
            Dati forniti volontariamente dall’utente tramite email (indirizzo
            email, nome, contenuto del messaggio).
          </Typography>
          <Typography component="li">
            Dati tecnici di navigazione raccolti automaticamente dai sistemi
            informatici e dal provider di hosting (indirizzo IP, tipo di browser,
            sistema operativo, orario delle richieste, log di accesso).
          </Typography>
        </Typography>

        <Typography variant="h6" gutterBottom>
          Finalità del Trattamento
        </Typography>
        <Typography component="ul" variant="body2" sx={{ pl: 3 }}>
          <Typography component="li">
            Rispondere alle richieste inviate via email.
          </Typography>
          <Typography component="li">
            Gestire comunicazioni di natura professionale o precontrattuale.
          </Typography>
          <Typography component="li">
            Garantire la sicurezza del sito e il corretto funzionamento tecnico.
          </Typography>
        </Typography>

        <Typography variant="h6" gutterBottom>
          Base Giuridica del Trattamento
        </Typography>
        <Typography component="ul" variant="body2" sx={{ pl: 3 }}>
          <Typography component="li">
            Art. 6(1)(b) GDPR – esecuzione di misure precontrattuali richieste
            dall’interessato.
          </Typography>
          <Typography component="li">
            Art. 6(1)(f) GDPR – legittimo interesse alla sicurezza informatica e
            gestione delle comunicazioni.
          </Typography>
        </Typography>

        <Typography variant="h6" gutterBottom>
          Modalità del Trattamento
        </Typography>
        <Typography variant="body2" paragraph>
          Il trattamento avviene con strumenti informatici e telematici nel
          rispetto dei principi di liceità, correttezza, trasparenza e sicurezza,
          adottando misure adeguate per prevenire accessi non autorizzati o perdita
          di informazioni.
        </Typography>

        <Typography variant="h6" gutterBottom>
          Comunicazione a Terzi
        </Typography>
        <Typography variant="body2" paragraph>
          I dati non sono oggetto di diffusione. Possono essere trattati da
          soggetti terzi che forniscono servizi tecnici necessari al funzionamento
          del sito, come provider di hosting, email e servizi IT di manutenzione.
        </Typography>

        <Typography variant="h6" gutterBottom>
          Periodo di Conservazione
        </Typography>
        <Typography variant="body2" paragraph>
          Le email ricevute sono conservate per il tempo necessario a gestire la
          richiesta e comunque non oltre 12 mesi, salvo obblighi di legge.
        </Typography>

        <Typography variant="h6" gutterBottom>
          Cookie e Local Storage
        </Typography>
        <Typography variant="body2" paragraph>
          Il sito non utilizza cookie di profilazione. Può utilizzare tecnologie
          tecniche necessarie al funzionamento e il <strong>local storage</strong>{" "}
          del browser per memorizzare preferenze come il tema grafico.
        </Typography>

        <Typography variant="h6" gutterBottom>
          Diritti dell’Interessato
        </Typography>
        <Typography variant="body2" paragraph>
          L’utente può esercitare i diritti previsti dagli artt. 15–22 GDPR:
          accesso, rettifica, cancellazione, limitazione, opposizione, portabilità
          dei dati e reclamo all’autorità di controllo.
        </Typography>

        <Typography variant="caption" display="block" mt={3}>
          Ultimo aggiornamento: 31 gennaio 2026
        </Typography>
      </Box>
    </Container>
  );
};

export default PrivacyPolicy;
